import React, {useState, useRef, useMemo} from 'react'
import PopSelect from '../../ReservationConfiguration/ActionSteps/PopSelect'
import PopSelectOption from '../../ReservationConfiguration/ActionSteps/PopSelectOption'

const Select = ({
  label = '',
  value = '',
  onChange = e => {},
  children = [],
  options = [],
  renderSelected = (options, v) => options.find(v),
  renderOption = (v, k) => v,
  returnValue = v => v,
}) => {
  const [open, setOpen] = useState(false)
  const refAnchor = useRef(null)

  const handleClickOption = (e, data) => {
    onChange(e, returnValue(data))
    setOpen(false)
  }

  return (
    <div
      className={`MuiFormControl-root MuiTextField-root c-res-mod ap-form-control ap-textfield ${(open ||
        value) &&
        'ap-form-control--focused'}`}
      style={{width: 200, marginTop: 16}}
    >
      <label
        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined"
        data-shrink="false"
      >
        {label}
      </label>
      <div
        ref={refAnchor}
        className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
        onClick={e => setOpen(true)}
      >
        <div
          className="MuiSelect-root MuiSelect-select MuiSelect-selectMenu MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
          tabIndex="0"
          role="button"
          aria-haspopup="listbox"
        >
          {renderSelected(options, value) || <span>&#8203;</span>}
        </div>
        <input type="hidden" value={value} />
        <svg
          className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined"
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M7 10l5 5 5-5z"></path>
        </svg>
        <fieldset
          aria-hidden="true"
          className="PrivateNotchedOutline-root-215 MuiOutlinedInput-notchedOutline"
        >
          <legend className="PrivateNotchedOutline-legendLabelled-217">
            <span>{label}</span>
          </legend>
        </fieldset>
      </div>
      <PopSelect anchorEl={refAnchor.current} open={open} onClose={e => setOpen(false)}>
        {options.map((o, i) => (
          <PopSelectOption key={i} onClick={e => handleClickOption(e, o)}>
            {renderOption(o, i)}
          </PopSelectOption>
        ))}
      </PopSelect>
    </div>
  )
}

export default Select
